<template>
  <div class="tour-detail-header">
    <div class="container container-header">
      <ul class="breadcrumbs">
        <div class="breadcrumb-container">
          <li class="active back">
            <nuxt-link :to="'/' +tour.citySlug">
              <img class="breadcrumb-icon" src="~/assets/svg/breadcrumbs-arrow.svg" />
              <span>{{tour.citySlug.split('-').join(' ')}}</span>
            </nuxt-link>
          </li>
        </div>
        <div class="header-content">
          <div class="header-left">
            <li>
              <h1 class="page-title page-title-detail" v-html="tour.title"></h1>
            </li>
            <div class="rating-awards-container">
              <RatingReview :rate="tour.reviewsAverage" :count="tour.reviewsCount" scrollTo="reviews"/>
            </div>
          </div>
          <div class="header-right d-none d-md-flex">
            <div v-for="(award, index) in tour.awards" :key="index" class="award-item">
              <span :id="'award-' + index">
                <img :src="award.image" :alt="award.title + ' - ' + award.description" class="award-image">
              </span>
              <BTooltip :target="'award-' + index" triggers="hover" placement="left" custom-class="award-tooltip">
                {{ award.description }}
              </BTooltip>
            </div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import RatingReview from '~/components/utils/RatingReview'
import promoMixin from '~/mixins/promoMixin.js'
import { BTooltip } from 'bootstrap-vue'

export default {
  name: 'TourDetailHeader',
  mixins: [promoMixin],
  components: {
    RatingReview,
    BTooltip
  },
  props: {
    tour: {
      type: Object,
      required: true
    }
  },
  methods: {
    getSlugRef(slug) {
      return '/' + slug + '/'
    },
  }
}
</script>

<style lang="scss" scoped>
.tour-detail-header {
  width: 100%;
  background: white;

  .container-header {
    display: flex;
  }

  .breadcrumbs li.active a {
    margin-bottom: 0px !important;
  }

  .breadcrumb-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media screen and (max-width: 640px) {
      margin-bottom: 33px;
    }
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header-left {
    flex: 1;
  }

  .header-right {
    align-items: center;
    margin-left: 20px;
  }

  .rating-awards-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include max-width($tablet) {
      margin-top: 10px;
    }
  }

  .award-item {
    margin-left: 10px;
  }

  .award-image {
    height: 150px;
    width: auto;
    margin: 0px;
    padding: 0px;
  }

  h1 {
    font-size: 40px !important;
    line-height: 52px;
    font-weight: 700 !important;
    color: $woi-red-main;

    @include max-width($tablet) {
      font-size: 32px !important;
      font-weight: 600 !important;
      line-height: 42px;
      padding-right: 45px;
    }
  }

  .price-right {
    padding: 60px;
    padding-bottom: 30px;
    display: flex;

    .count {
      span {
        color: white !important;
      }
    }

    >div {
      h2 {
        font-size: 70px !important;
      }

      margin: auto;
    }

    width: 350px;
    background-color: $woi-red-main;

    @include max-width($desktop-sm) {
      display: none;
    }

    h3 {
      font-family: 'Vollkorn' !important;
    }

    .price-header {
      display: flex;
      align-items: center;

      >span:first-child {
        font-size: 46px;
      }
    }
  }
}

.free-cancellation {
  margin-top: 30px;
}

.free-cancellation,
.icon-checkmark {
  color: #A08F56;
  margin-right: 5px;
}

.breadcrumbs li.back {
  display: block;
  a {
    color: $blackberry;
    font-family: "Open Sans";
    font-size: 16px !important;
    font-style: normal;
    font-weight: 600;
    line-height: 19px; /* 118.75% */
    text-transform: uppercase;
    display: flex;
    align-items: center;

    .breadcrumb-icon {
      width: 24px;
      height: 24px;
      margin: 0;
      margin-right: 4px;
    }
  }
}

::v-deep .tooltip-inner {
  max-width: 200px !important;
}
</style>
